//NOT EDITABLE!!!
import Hero from "../../components/Hero";
import Header from "../../components/Header";
import Main from "../../components/Main"
import Footer from "../../components/Footer";
import "./style.css"


function pageLayout(props) {

  return (
    <div className="app">
      <Header/>
      <Main/>
      <Footer/>
    </div>
  );
}

export default pageLayout;
